const FILTERS_SHOW = 'modules/manageFiltersModal/SHOW';
const FILTERS_HIDE = 'modules/manageFiltersModal/HIDE';

const reducer = (state = false, action) => {
  switch (action.type) {
    case FILTERS_SHOW:
      return true;
    case FILTERS_HIDE:
      return false;
    default:
      return state;
  }
};

const showFilters = () => ({ type: FILTERS_SHOW });
const hideFilters = () => ({ type: FILTERS_HIDE });

export { reducer as default, showFilters, hideFilters };
